import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <>
      <h1 className="m-0 text-[26px] font-black tracking-[-0.01em]">Page introuvable</h1>
      <p className="m-0 text-sm text-muted-foreground">
        <Link to="/">Retour à l'accueil</Link>
      </p>
    </>
  );
}
